import { IDisposer } from './Types'
import { type Merge } from 'stores/Merge'

export class MergeDisposer implements IDisposer {
  merge: Merge

  constructor(merge: Merge) {
    this.merge = merge
  }

  setView() {}

  accept = async (uuids: string[]) => {
    uuids.forEach((uuid) => this.merge.include(uuid))
  }

  reject = (uuid: string) => {
    this.merge.exclude(uuid)
  }

  rejectAll = () => {}

  get canAcceptChanges() {
    return false
  }

  get canRejectChanges() {
    return false
  }

  get isDispositioning() {
    return false
  }
}
